import { END_POINT } from "../constants";
import { HTTP } from "./http";

export const GalleryService = {
  getAll: () => {
    return HTTP.get(`${END_POINT}galleries`);
  },
}